import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var styledLabel = createRuntimeFn({defaultClassName:'fx_2d2fb1e5_34isl00',variantClassNames:{size:{small:'fx_2d2fb1e5_34isl01','default':'fx_2d2fb1e5_34isl02',large:'fx_2d2fb1e5_34isl03',xlarge:'fx_2d2fb1e5_34isl04'}},defaultVariants:{},compoundVariants:[]});

export { styledLabel };
//# sourceMappingURL=label.vanilla.mjs.map
